var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticStyle:{"height":"53vh"}},[_c('v-alert',{attrs:{"outlined":"","type":"success","text":""}},[_vm._v(" Confirmation message has been sent to your email. Please check your email. ")])],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }